// @flow
import { useCallback } from 'react';

import type { FormActions } from 'app/get-help/components/Form/types';
import type { SelectedNode } from 'app/get-help/utils/tree/types';
import type { States } from 'app/get-help/components/Form/machine';

type Props = {
  actions: FormActions,
  node: SelectedNode,
  state: States,
};

const Node = ({
  actions: { answer, unanswer, ...passedActions },
  node,
  state,
}: Props) => {
  // eslint-disable-next-line no-unused-vars
  const { render, export: _export, ...passedNodeProps } = node;

  const answerWithPath = useCallback(
    data => {
      answer(node.pathId, data);
    },
    [node, answer]
  );

  const unanswerWithPath = useCallback(() => {
    unanswer(node.pathId);
  }, [node, unanswer]);

  return render({
    ...passedNodeProps,
    actions: {
      answer: answerWithPath,
      unanswer: unanswerWithPath,
      ...passedActions,
    },
    state,
  });
};

export default Node;
